import React from "react";
import { useTranslation } from "../../i18n/LanguageProvider";

function formatDate(resource, locale) {
  if (!(resource.parsedDate instanceof Date) || isNaN(resource.parsedDate)) return resource.dateAdded;
  try {
    return new Intl.DateTimeFormat(locale, { year: "numeric", month: "short", day: "numeric" })
      .format(resource.parsedDate);
  } catch (error) {
    return resource.dateAdded;
  }
}

export default function ResourceCard({ resource, selectedTags = [], onTagClick }) {
  const { locale, t } = useTranslation();

  return (
    <article className="publication-entry" data-layout="text">
      <div className="publication-entry-body">
        <div className="publication-overline">
          <span>{formatDate(resource, locale)}</span>
          {resource.tags.map((tag) => (
            <button
              key={tag}
              type="button"
              className="resource-tag"
              data-tag={tag === "NEW" ? "new" : undefined}
              aria-pressed={selectedTags.includes(tag)}
              aria-label={t("resources.filterBy", { tag })}
              onClick={() => onTagClick?.(tag)}
            >
              {tag}
            </button>
          ))}
        </div>
        <h3>
          <a href={resource.url} target="_blank" rel="noopener noreferrer">{resource.title}</a>
        </h3>
        <p className="resource-reference">{resource.reference}</p>
      </div>
    </article>
  );
}
